/* global alert */

// eslint-disable-next-line import/no-extraneous-dependencies
import jsonExport from 'jsonexport/dist';
import omit from 'lodash/omit';
import { downloadCSV } from 'react-admin';

const swExporter = (sws) => {
  const swsForExport = sws.map((sw) => {
    const swFieldsToOmit = [
      '_token',
      'admin_note',
      'admin_url',
      'booking_confirmation_email_sent_at',
      'booking_confirmation_sms_sent_at',
      'box',
      'checkin_keyosk_id',
      'checkin_lat',
      'checkin_lng',
      'client_location',
      'client_location',
      'confirmed_appointment_start_time',
      'customer_address_id',
      'customer_address',
      'customer_checked_in_at',
      'customer_diagnostic_note',
      'customer_home_additional_note',
      'customer_location',
      'customer_note',
      'customer_schedule_note',
      'customer_tire_note',
      'customer.admin_note',
      'customer.admin_url',
      'customer.created_at',
      'customer.custom_referral_code',
      'customer.customer_id',
      'customer.customer_support_contact_via_call',
      'customer.customer_support_contact_via_email',
      'customer.customer_support_contact_via_text',
      'customer.default_client_location_id',
      'customer.generated_referral_code',
      'customer.gravatar_image_url',
      'customer.gravatar_profile_url',
      'customer.has_created_password',
      'customer.how_did_hear',
      'customer.id',
      'customer.is_deleted',
      'customer.is_guest',
      'customer.is_opted_out_of_carfax_reporting',
      'customer.modified_at',
      'customer.notifications_via_email',
      'customer.notifications_via_text',
      'customer.pro_name',
      'customer.subusers',
      'customer.zipchat_conversation_sid',
      'day_before_email_sent_at',
      'day_before_sms_sent_at',
      'delivery_checklist_completed_at',
      'executive_summary',
      'final_trailer_checklist_completed_at',
      'has_unapproved_upsells',
      'hc_is_complete',
      'health_check_end_time',
      'health_check_id',
      'health_check_start_time',
      'health_check_url',
      'health_check',
      'id',
      'st_order_id',
      'tracking_url',
      'product_sizes',
      'tire_quantity',
      'product_details',
      'st_company_name',
      'inspection_results_summary',
      'inspection_results',
      'is_at_home_service',
      'is_created_by_admin',
      'is_created_from_mobile_app',
      'is_handraise',
      'is_pickup_and_delivery',
      'is_recurring',
      'key_exchange_note',
      'keyosk_id',
      'keyosk',
      'lead_tech_nag_sent_at',
      'mileage',
      'nag_sms_sent_at',
      'next_service_date',
      'next_service_offering_id_0',
      'next_service_offering_id_1',
      'next_service_offering_id_2',
      'next_service_offering_id_3',
      'number_of_edits',
      'on_our_way_sms_sent_at',
      'parking_id',
      'parking',
      'payment_note',
      'pinX',
      'pinY',
      'planned_arrival_time',
      'planned_departure_time',
      'pro_name',
      'receipt_sent_at',
      'referrer_code',
      'review_request_sent',
      'schedule_device',
      'service_complete_sms_email_sent_at',
      'service_started_sms_sent_at',
      'technician_note',
      'tip_request_sent_at',
      'token_expires_at',
      'unstarted_sms_sent_at',
      'vehicle_service_requirements_note',
      'vehicle.aces_base_vehicle_id',
      'vehicle.aces_body_type_name',
      'vehicle.aces_engine_base_id',
      'vehicle.aces_fuel_type_name',
      'vehicle.aces_make_id',
      'vehicle.aces_make_name',
      'vehicle.aces_model_id',
      'vehicle.aces_model_name',
      'vehicle.aces_submodel_id',
      'vehicle.aces_submodel_name',
      'vehicle.aces_vehicle_id',
      'vehicle.aces_year_id',
      'vehicle.admin_url',
      'vehicle.bed_type_lengths',
      'vehicle.body_style_types',
      'vehicle.created_at',
      'vehicle.customer_id',
      'vehicle.customer',
      'vehicle.display_name',
      'vehicle.fuel_quality',
      'vehicle.fuel_type',
      'vehicle.heavy_duty_engine_make',
      'vehicle.heavy_duty_engine_serial_number',
      'vehicle.ice_displacement',
      'vehicle.id',
      'vehicle.input_method_type',
      'vehicle.inspection_expiration',
      'vehicle.is_deleted',
      'vehicle.is_verified_from_license_plate',
      'vehicle.is_verified_from_vin',
      'vehicle.license_plate_expiration',
      'vehicle.modified_at',
      'vehicle.motor_base_vehicle_id',
      'vehicle.motor_engine_id',
      'vehicle.motor_image_api_url',
      'vehicle.motor_last_refreshed',
      'vehicle.motor_oil_spec_api_url',
      'vehicle.motor_sub_model_id',
      'vehicle.motor_tire_spec_api_url',
      'vehicle.motor_vehicle_id',
      'vehicle.oil_capacities',
      'vehicle.oil_capacity',
      'vehicle.oil_viscosities',
      'vehicle.photo_filenames',
      'vehicle.preferred_oil_spec_id',
      'vehicle.pro_name',
      'vehicle.pt_base_msrp',
      'vehicle.pt_front_tire_pressure_lbs',
      'vehicle.pt_front_tire_size',
      'vehicle.pt_rear_tire_pressure_lbs',
      'vehicle.pt_rear_tire_size',
      'vehicle.pt_segmentation_description',
      'vehicle.pt_vehicle_type_description',
      'vehicle.pt_wheel_base_longest_inches',
      'vehicle.pt_wheel_base_shortest_inches',
      'vehicle.selected_tire_pressure',
      'vehicle.selected_tire_size',
      'vehicle.standard_tire_sizes',
      'vehicle.technician_verified_tire_size',
      'vehicle.tire_pressures',
      'vehicle.vehicle_id',
      'vehicle.wheel_base_lengths',
      'waitlist_note',
    ];

    const serviceFieldsToOmit = [
      'add_oil_cost',
      'cancel_reason',
      'copied_from_service_id',
      'created_at',
      'employee_note',
      'id',
      'inspection_id',
      'is_parts_planned',
      'is_upsell',
      'labor_hours',
      'long_name',
      'marketing_url',
      'modified_at',
      'original_value_dollars',
      'parts_allocated',
      'parts_consumed',
      'pro_name',
      'reason_for_not_rescheduling',
      'replaced_by_service_id',
      'schedule_types',
      'scheduled_work_id',
      'service_id',
      'service_offering_id',
      'short_name',
      'suggest_reschedule',
      'upsell_date',
      'upsell_rejection_reason',
      'upsell_status',
      'variable_pricing',
      'service_payment_status',
    ];

    const cleanServices = sw.services.map((s) => omit(s, serviceFieldsToOmit));
    const cleanSw = omit(sw, swFieldsToOmit);
    cleanSw.services = cleanServices;
    return cleanSw;
  });

  jsonExport(swsForExport, (err, csv) => {
    if (err) {
      console.log(err);
      return alert('Sorry, something went wrong during this export');
    }
    return downloadCSV(csv, 'scheduled-work');
  });
};

export default swExporter;
